import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { MapPinIcon, MailIcon, InstagramIcon, PlusIcon } from 'lucide-react';
import { BUSINESSES } from '../data';
import { useCart } from '../CartContext';
import { Reveal } from '../components/Reveal';
export function PartnerPage() {
  const {
    slug
  } = useParams();
  const {
    addToCart
  } = useCart();
  const business = BUSINESSES.find(b => b.slug === slug);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);
  if (!business) {
    return <div className="pt-32 text-center" data-id="element-374" data-mp="2w7n9ux7room5">Verksamheten hittades inte.</div>;
  }
  return <div className="min-h-screen bg-warm pb-20" data-id="element-375" data-mp="2hj0jm0glqcg5">
      {/* Hero Section */}
      <div className="relative h-[50vh] w-full overflow-hidden md:h-[60vh]" data-id="element-376" data-mp="2mgitpu6cuxpq">
        <img src={business.cover} alt={business.name} className="absolute inset-0 h-full w-full object-cover" data-id="element-377" data-mp="28h9dwvm2a5ma" />
        <div className="absolute inset-0 bg-gradient-to-t from-brun/80 via-brun/30 to-transparent" data-id="element-378" data-mp="2cimm3ccmmkwd" />
        <div className="absolute bottom-0 left-0 w-full p-6 md:p-10" data-id="element-379" data-mp="1vwcsetb36mqd">
          <div className="mx-auto max-w-7xl" data-id="element-380" data-mp="1vypgzpbcnvce">
            {business.place && <p className="text-[12px] uppercase tracking-wide3 text-warm/70" data-id="element-381" data-mp="1qwqesircj4h1">{business.place}</p>}
            <h1 className="mt-2 font-display text-5xl font-light text-warm md:text-7xl" data-id="element-382" data-mp="25thgiyohss9t">{business.name}</h1>
            <p className="mt-4 text-sm uppercase tracking-wide2 text-terrakotta" data-id="element-383" data-mp="20w8w0rfvgc5e">{business.services}</p>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-16 grid max-w-7xl gap-16 px-6 md:grid-cols-[1fr,300px] md:px-10" data-id="element-384" data-mp="18720m1bps2od">
        {/* Main Content */}
        <div data-id="element-385" data-mp="1mw6ex7fe1mr7">
          <Reveal data-id="element-386" data-mp="1mwq150c2mxb1">
            <div className="space-y-6 text-lg leading-relaxed text-brun-soft" data-id="element-387" data-mp="1mx985m06o1aa">
              {business.description.map((p, i) => <p key={i} data-id="element-388" data-mp="1i3dbqnzkimh8" data-mpi={i}>{p}</p>)}
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-389" data-mp="ue2irsoglwdn">
            <h2 className="mt-20 font-display text-3xl text-brun" data-id="element-390" data-mp="udaoqmaig6ph">Sortiment</h2>
            <div className="mt-8 grid gap-6 sm:grid-cols-2" data-id="element-391" data-mp="pgaiobdnv3yd">
              {business.products.map(product => <div key={product.id} className="group overflow-hidden rounded-sm border border-brun/10 bg-beige transition-colors hover:border-brun/30" data-id="element-392" data-mp="1f2vc87njw9pw">
                  <div className="relative h-48 overflow-hidden" data-id="element-393" data-mp="1ny1e4vjpa7n5">
                    <img src={product.image} alt={product.name} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-394" data-mp="1svtdgamocw1d" />
                    <div className="absolute left-3 top-3 rounded-full bg-warm/90 px-3 py-1 text-[10px] uppercase tracking-wide2 text-brun backdrop-blur-sm" data-id="element-395" data-mp="w7n5bdqjnlic">
                      {product.category}
                    </div>
                  </div>
                  <div className="flex items-center justify-between p-5" data-id="element-396" data-mp="1a64p50dbwduz">
                    <h3 className="font-display text-xl text-brun" data-id="element-397" data-mp="2glnnyljiu8ig">{product.name}</h3>
                    <button onClick={() => addToCart(product)} className="flex h-10 w-10 items-center justify-center rounded-full bg-skog text-warm transition-transform hover:scale-110 hover:bg-brun" aria-label="Lägg till i förfrågan" data-id="element-398" data-mp="2go1i8s6dngoy">
                      <PlusIcon className="h-5 w-5" data-id="element-399" data-mp="7by8kd7c4gn" />
                    </button>
                  </div>
                </div>)}
            </div>
          </Reveal>
        </div>

        {/* Sidebar */}
        <aside className="space-y-10" data-id="element-400" data-mp="3ncl2057uv38n">
          <Reveal delay={0.2} data-id="element-401" data-mp="3ndmfshg9a3u2">
            <div className="rounded-sm border border-brun/10 bg-beige p-6" data-id="element-402" data-mp="3id85esr6mhsv">
              <h3 className="font-display text-xl text-brun" data-id="element-403" data-mp="3ifb6c7tvhvcd">Kontakt & Info</h3>
              <ul className="mt-6 space-y-4 text-sm text-brun-soft" data-id="element-404" data-mp="3denczfi692ez">
                <li className="flex items-start gap-3" data-id="element-405" data-mp="38fu27uu9rpii">
                  <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-terrakotta" data-id="element-406" data-mp="38hewdjco96fu" />
                  <span data-id="element-407" data-mp="1bko57449d371">{business.contact.address}</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-408" data-mp="16oyz0hxqgo1r">
                  <MailIcon className="h-4 w-4 shrink-0 text-terrakotta" data-id="element-409" data-mp="1eomydvb8hf2q" />
                  <a href={`mailto:${business.contact.email}`} className="hover:text-skog" data-id="element-410" data-mp="1emiv9fl5sk3i">{business.contact.email}</a>
                </li>
                <li className="flex items-center gap-3" data-id="element-411" data-mp="14qz1ayq5nvhe">
                  <InstagramIcon className="h-4 w-4 shrink-0 text-terrakotta" data-id="element-412" data-mp="14sjv2m4nbae7" />
                  <a href="#" className="hover:text-skog" data-id="element-413" data-mp="19nfpfsxcu9uh">{business.contact.instagram}</a>
                </li>
              </ul>
            </div>
          </Reveal>

          <Reveal delay={0.3} data-id="element-414" data-mp="10oucqeekdp1m">
            <div data-id="element-415" data-mp="10pwzqb8rn7c9">
              <h3 className="text-[11px] uppercase tracking-wide2 text-brun-soft" data-id="element-416" data-mp="10qf4xxdeovwb">Perfekt för</h3>
              <ul className="mt-4 flex flex-wrap gap-2" data-id="element-417" data-mp="lxv453dqb0i1">
                {business.perfectFor.map(occasion => <li key={occasion} className="rounded-full border border-brun/15 px-3 py-1.5 text-xs text-brun-soft" data-id="element-418" data-mp="cz01205ze6iy">
                    {occasion}
                  </li>)}
              </ul>
            </div>
          </Reveal>
        </aside>
      </div>
    </div>;
}